import { useContext } from 'react';
import { Avatar, Box, Card, Chip, Grid, Typography } from '@mui/material'
import { SocketContext } from '../../context/SocketContext';
import { useNavigate } from 'react-router-dom';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import FechaFunction from '../../function/FechaFunction';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { showModal } from 'react-redux-modal-provider';
import ModalRecordatorioById from '../../modals/recordatorios/ModalRecordatorioById';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ReportIcon from '@mui/icons-material/Assessment';
import EventIcon from '@mui/icons-material/Event';
const CardNotifyGral = ({item,onCloseModal,isDarkMode}) => {
    const navigate = useNavigate();
    const { sockets } = useContext( SocketContext );
    const redirect = ()=>{
        if(!item?.visto_notfg){
            sockets?.emit('newNotificationsGral', item?.id_notfg)
        }
        const separados = item?.redirect_notfg?.split('-');
        if(separados?.length > 0){
            switch (separados[0]) {
                case 'reportes':
                    navigate('/reports')
                    break;
                case 'recordatorios':
                    showModal(ModalRecordatorioById,{id: separados[1]})
                    break;
                default:
                    navigate('/')
                    break;
            }
            if(onCloseModal){
                onCloseModal()
            }
        }
    }
    const getCompanyInfo = (empresa) => {
        const companies = {
            'nubicom': { logo: '/img/nubi-cirucular.png', name: 'Nubicom', color: '#0364FF' },
            'ids': { logo: '/img/ids-logo.png', name: 'IDS', color: '#10b981' },
            'strong': { logo: '/img/strong-logo.png', name: 'Strong', color: '#f59e0b' },
            'cvv': { logo: '/img/911-logo.png', name: 'CVV', color: '#ef4444' }
        };
        return companies[empresa] || { logo: '', name: empresa, color: '#6b7280' };
    };

    const getNotificationTypeInfo = (redirect) => {
        const separados = redirect?.split('-');
        if (separados?.length > 0) {
            switch (separados[0]) {
                case 'reportes':
                    return {
                        icon: <ReportIcon sx={{ fontSize: 14 }} />,
                        color: '#3b82f6',
                        type: 'Reporte'
                    };
                case 'recordatorios':
                    return {
                        icon: <EventIcon sx={{ fontSize: 14 }} />,
                        color: '#f59e0b',
                        type: 'Recordatorio'
                    };
                default:
                    return {
                        icon: <NotificationsIcon sx={{ fontSize: 14 }} />,
                        color: '#6b7280',
                        type: 'General'
                    };
            }
        }
        return {
            icon: <NotificationsIcon sx={{ fontSize: 14 }} />,
            color: '#6b7280',
            type: 'General'
        };
    };

    const companyInfo = getCompanyInfo(item?.empresa_notfg);
    const typeInfo = getNotificationTypeInfo(item?.redirect_notfg);

    return (
        <Card
            sx={{
                background: item?.visto_notfg 
                    ? isDarkMode 
                        ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                        : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)' 
                    : isDarkMode
                        ? 'linear-gradient(135deg, #1a2744 0%, #243352 100%)'
                        : 'linear-gradient(135deg, #e6f0ff 0%, #f0f8ff 100%)',
                border: item?.visto_notfg 
                    ? isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed' 
                    : `1px solid ${companyInfo.color}40`,
                borderRadius: 3,
                p: 1.5,
                mt: 1,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                    transform: 'translateX(4px)',
                    boxShadow: `0 4px 20px ${companyInfo.color}20`,
                    border: `1px solid ${companyInfo.color}60`
                },
                '&::before': item?.visto_notfg ? {} : {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: 4,
                    height: '100%',
                    background: companyInfo.color,
                    borderRadius: '0 2px 2px 0'
                }
            }}
            onClick={()=>redirect()}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {/* Company Avatar */}
                <Avatar 
                    src={companyInfo.logo} 
                    sx={{ 
                        width: 36, 
                        height: 36,
                        border: `2px solid ${companyInfo.color}30`,
                        boxShadow: `0 2px 8px ${companyInfo.color}20`
                    }} 
                />
                
                {/* Content */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    {/* Header with user and company */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                        <Typography 
                            sx={{ 
                                color: isDarkMode ? '#e0e0e0' : '#2d3748', 
                                fontSize: 14, 
                                fontWeight: 600,
                                lineHeight: 1.2
                            }}
                        >
                            {item?.senduser?.nombre_p || 'Sistema'}
                        </Typography>
                        <Chip 
                            label={companyInfo.name}
                            size="small"
                            sx={{
                                height: 20,
                                fontSize: 10,
                                fontWeight: 600,
                                backgroundColor: `${companyInfo.color}15`,
                                color: companyInfo.color,
                                border: `1px solid ${companyInfo.color}30`,
                                '& .MuiChip-label': {
                                    px: 1
                                }
                            }}
                        />
                        <Chip 
                            icon={typeInfo.icon}
                            label={typeInfo.type}
                            size="small"
                            sx={{
                                height: 20,
                                fontSize: 10,
                                fontWeight: 600,
                                backgroundColor: `${typeInfo.color}15`,
                                color: typeInfo.color,
                                border: `1px solid ${typeInfo.color}30`,
                                '& .MuiChip-label': {
                                    px: 1
                                },
                                '& .MuiChip-icon': {
                                    fontSize: 12,
                                    color: typeInfo.color
                                }
                            }}
                        />
                    </Box>

                    {/* Notification description */}
                    <Typography 
                        sx={{ 
                            color: isDarkMode ? '#b0bec5' : '#4a5568', 
                            fontSize: 13, 
                            lineHeight: 1.3,
                            mb: 0.5
                        }}
                    >
                        {item?.descripcion_notfg}
                    </Typography>

                    {/* Time info */}
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <AccessTimeOutlinedIcon sx={{ fontSize: 12, color: '#a0aec0' }} />
                            <Typography sx={{ color: '#a0aec0', fontSize: 11 }}>
                                {FechaFunction.timeAgoMentions(new Date(item?.createdAt))}
                            </Typography>
                        </Box>
                        {item?.visto_notfg && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <RemoveRedEyeIcon sx={{ fontSize: 12, color: '#029e3e' }} />
                                <Typography sx={{ color: '#029e3e', fontSize: 11 }}>
                                    Visto {FechaFunction.timeAgoMentions(new Date(item?.visto_notfg))}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Card>
    )
}

export default CardNotifyGral


